@if (breadcrumbs && breadcrumbs.length > 0) {
<div class="p2">
    @for (crumb of breadcrumbs; track $index; let isLast = $last) {
    @if (!isLast) {
    <a [routerLink]="crumb.url"
       class="col-12 m-b-2">{{crumb.label}}</a>
    <i class="icon-chevron-right p-l-2 p-r-2 col-42"
       [style.font-size.em]=".8"></i>
    }
    @if (isLast) {
    <span class="col-11 inline-block">{{crumb.label}}</span>
    }
    }
</div>
}